/**
 * Top of the Início (HOME-01): the greeting by time of day and the eyebrow
 * with the date.
 */
import type { DateTime } from 'luxon';
import type { Locales, TranslationFunctions } from '@/i18n/i18n-types';
import { getLuxonLocale } from '@/lib/utils';

/** "Bom dia" 05:00–11:59, "Boa tarde" 12:00–17:59, "Boa noite" otherwise. */
export function greetingFor(now: DateTime, LL: TranslationFunctions): string {
  if (now.hour >= 5 && now.hour < 12) return LL.home.greeting.morning();
  if (now.hour >= 12 && now.hour < 18) return LL.home.greeting.afternoon();
  return LL.home.greeting.evening();
}

/**
 * "Início — segunda-feira, 19 de outubro". The all-caps look is CSS
 * (`uppercase`), so the text itself keeps its case.
 */
// SPEC_DEVIATION: takes `LL` too (design: `homeEyebrow(now, locale)`).
// Reason: "Início"/"Home" is translated.
export function homeEyebrow(
  now: DateTime,
  locale: Locales,
  LL: TranslationFunctions
): string {
  const date = now
    .setLocale(getLuxonLocale(locale))
    .toLocaleString({ weekday: 'long', day: 'numeric', month: 'long' });
  return LL.home.eyebrow({ date });
}
